import React from 'react';
import includes from 'lodash/includes';
import PropTypes from 'prop-types';

import TextInput from '../../TextInput';
import SelectCustom from '../../SelectCustom';
import { FormErrorBlock } from '../FormErrorBlock';
import TermsAndConditions from '../../TermsAndConditions';
import { PROFILE_FIELDS_TYPES } from '../../../constants/formFields';
import {
  FIELD_FILLING_TYPES,
  getFieldProps,
} from '../../../utils/fields/getFieldProps';
import { MobilePhone } from '../../MobilePhone';
import { enhance } from './enhance';

const FieldsList = ({
  fields,
  formState,
  relationshipOptions,
  roleOptions,
  loggedUserCountry,
  validateErrors,
  formatMessage,
  onChange,
  handleFieldOptions,
  initialData,
  customRoleOptions,
  className,
}) => {
  const makeProfileField = getFieldProps(formatMessage, onChange);

  const checkOptionHandler = (field, options) => {
    const handler = handleFieldOptions[field];

    if (handler) {
      return handler(options, initialData);
    }

    return options;
  };

  return (
    <div className={className}>
      {/*     ROLE     */}
      <If condition={includes(fields, PROFILE_FIELDS_TYPES.ROLE)}>
        <SelectCustom
          {...makeProfileField(PROFILE_FIELDS_TYPES.ROLE)}
          options={checkOptionHandler(
            PROFILE_FIELDS_TYPES.ROLE,
            customRoleOptions || roleOptions,
          )}
          value={formState[PROFILE_FIELDS_TYPES.ROLE]}
        />
      </If>
      {/*     RELATIONSHIP     */}
      <If condition={includes(fields, PROFILE_FIELDS_TYPES.RELATIONSHIP)}>
        <SelectCustom
          {...makeProfileField(PROFILE_FIELDS_TYPES.RELATIONSHIP)}
          options={relationshipOptions}
          value={formState[PROFILE_FIELDS_TYPES.RELATIONSHIP]}
        />
      </If>
      {/*     LOGIN     */}
      <If condition={includes(fields, PROFILE_FIELDS_TYPES.LOGIN)}>
        <TextInput
          {...makeProfileField(PROFILE_FIELDS_TYPES.LOGIN)}
          value={formState[PROFILE_FIELDS_TYPES.LOGIN]}
        />
        <FormErrorBlock
          type={PROFILE_FIELDS_TYPES.LOGIN}
          errors={validateErrors}
        />
      </If>
      {/*     EMAIL_OR_PHONE     */}
      <If condition={includes(fields, PROFILE_FIELDS_TYPES.EMAIL_OR_PHONE)}>
        <TextInput
          {...makeProfileField(PROFILE_FIELDS_TYPES.EMAIL_OR_PHONE)}
          value={formState[PROFILE_FIELDS_TYPES.EMAIL_OR_PHONE]}
        />
        <FormErrorBlock
          type={PROFILE_FIELDS_TYPES.EMAIL_OR_PHONE}
          errors={validateErrors}
        />
      </If>
      {/*     USERNAME     */}
      <If condition={includes(fields, PROFILE_FIELDS_TYPES.USERNAME)}>
        <TextInput
          {...makeProfileField(PROFILE_FIELDS_TYPES.USERNAME)}
          value={formState[PROFILE_FIELDS_TYPES.USERNAME]}
        />
        <FormErrorBlock
          type={PROFILE_FIELDS_TYPES.USERNAME}
          errors={validateErrors}
        />
      </If>
      {/*     CHAT_NAME     */}
      <If condition={includes(fields, PROFILE_FIELDS_TYPES.CHAT_NAME)}>
        <TextInput
          {...makeProfileField(PROFILE_FIELDS_TYPES.CHAT_NAME)}
          value={formState[PROFILE_FIELDS_TYPES.CHAT_NAME]}
        />
        <FormErrorBlock
          type={PROFILE_FIELDS_TYPES.CHAT_NAME}
          errors={validateErrors}
        />
      </If>
      {/*     TERM_AND_CONDITIONS     */}
      <If
        condition={includes(fields, PROFILE_FIELDS_TYPES.TERMS_AND_CONDITIONS)}
      >
        <TermsAndConditions
          {...makeProfileField(PROFILE_FIELDS_TYPES.TERMS_AND_CONDITIONS)}
          country={loggedUserCountry}
          acceptable
          secondaryContent
        />
        <FormErrorBlock
          type={PROFILE_FIELDS_TYPES.TERMS_AND_CONDITIONS}
          errors={validateErrors}
        />
      </If>
      {/*     EMAIL     */}
      <If condition={includes(fields, PROFILE_FIELDS_TYPES.EMAIL)}>
        <TextInput
          {...makeProfileField(PROFILE_FIELDS_TYPES.EMAIL)}
          value={formState[PROFILE_FIELDS_TYPES.EMAIL]}
        />
        <FormErrorBlock
          type={PROFILE_FIELDS_TYPES.EMAIL}
          errors={validateErrors}
        />
      </If>
      {/*     PHONE NUMBER     */}
      <If condition={includes(fields, PROFILE_FIELDS_TYPES.PHONE_NUMBER)}>
        <MobilePhone
          {...makeProfileField(
            PROFILE_FIELDS_TYPES.PHONE_NUMBER,
            FIELD_FILLING_TYPES.OPTIONAL,
          )}
          formatMessage={formatMessage}
          withValidation
        />
        <FormErrorBlock
          type={PROFILE_FIELDS_TYPES.PHONE_NUMBER}
          errors={validateErrors}
        />
      </If>
    </div>
  );
};

FieldsList.defaultProps = {
  formState: {},
  fields: [],
  handleFieldOptions: {},
};

FieldsList.propTypes = {
  customFieldStyles: PropTypes.object,
  fields: PropTypes.array,
  formState: PropTypes.object,
  handleFieldOptions: PropTypes.object,
  initialData: PropTypes.object,
  relationshipOptions: PropTypes.array.isRequired,
  loggedUserCountry: PropTypes.string,
  roleOptions: PropTypes.array.isRequired,
  validateErrors: PropTypes.object.isRequired,
  formatMessage: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  customRoleOptions: PropTypes.array,
  className: PropTypes.string,
};

export default enhance(FieldsList);



// WEBPACK FOOTER //
// ./src/components/common/FieldsList/index.jsx